// LayoutWithSidebarContainer.js - Enhanced Version
import React, { useCallback, useEffect } from "react";
import LayoutWithSidebar from "./LayoutWithSidebar";
import { useNavigate, useLocation } from "react-router-dom";

const LayoutWithSidebarContainer = ({ 
  brandTitle = "E-Invoicing Dashboard",
  showBrand = true,
  collapsible = false,
  ...restProps 
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Enhanced navigation handler with error handling
  const handleTabClick = useCallback((value) => {
    try {
      // Prevent navigation to the same route
      if (location.pathname === `/${value}`) {
        return;
      }

      // Optional: Add loading state or transition effect here
      navigate(`/${value}`);
      
      // Optional: Scroll to top after navigation
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
      
    } catch (error) {
      console.error('Navigation error:', error);
      // Fallback navigation
      window.location.href = `/${value}`;
    }
  }, [navigate, location.pathname]);

  // Handle browser back/forward buttons
  useEffect(() => {
    const handlePopState = () => {
      // Optional: Add any cleanup or state updates needed on navigation
      console.log('Navigation via browser buttons');
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Keyboard shortcuts for navigation (optional)
  useEffect(() => {
    const handleKeyboardShortcuts = (event) => {
      // Only handle shortcuts when not typing in inputs
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return;
      }

      // Alt + number keys for quick navigation
      if (event.altKey && event.key >= '1' && event.key <= '9') {
        event.preventDefault();
        const tabIndex = parseInt(event.key) - 1;
        // You could implement tab switching by index here
        console.log(`Quick navigation to tab ${tabIndex + 1}`);
      }
    };

    document.addEventListener('keydown', handleKeyboardShortcuts);
    return () => document.removeEventListener('keydown', handleKeyboardShortcuts);
  }, []);

  return (
    <LayoutWithSidebar 
      {...restProps}
      onTabClick={handleTabClick}
      brandTitle={brandTitle}
      showBrand={showBrand}
      collapsible={collapsible}
    />
  );
};

export default React.memo(LayoutWithSidebarContainer);